import React from "react";
import WidgetGrid from "../WidgetGrid";

export function GridWidget(props) {
  const { ui, config, createChildWidget } = props;

  let grid = config;

  return config 
  ? <WidgetGrid rows={grid.Rows} columns={grid.Columns} widgetLocations={grid.WidgetLocations} containingWidgets={ui.containingWidgets} createChildWidget={createChildWidget} /> 
  : <React.Fragment />;
}
